<template>
  <div :class="[
    cssClass,
    `widget-${variant} widget-content`,
    {
      'card border-transparent': !inset,
      'soft-shadow': shadow,
      'transparent': transparent
    }
  ]">
    <div :class="{
      'card-body': !inset,
    }">
      <slot name="widget-header">
        <widget-header
          :config="config"
        ></widget-header>
      </slot>
      <slot></slot>
      <slot name="widget-footer">
        <widget-footer
          :config="config"
          @refresh="$emit('refresh')"
        ></widget-footer>
      </slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.widget-content {
  height: 100%;
  &.transparent {
    background-color: transparent;
  }
}
</style>

<script>
import { get } from 'lodash'
import WidgetHeader from './WidgetHeader'
import WidgetFooter from './WidgetFooter'

export default {
  components: {
    WidgetHeader,
    WidgetFooter
  },

  props: {
    cssClass: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      required: true
    },
  },

  computed: {
    config () {
      return this.$parent.config
    },

    footer () {
      return get(this.config, 'footer') || '&nbsp;'
    },

    shadow () {
      return get(this.config, 'options.shadow', true)
    },

    transparent () {
      return get(this.config, 'options.transparent', false)
    },

    inset () {
      return get(this.config, 'options.inset', false)
    }
  },

  methods: {
    refresh () {
      this.$emit('refresh')
    }
  }
}
</script>